/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardDevolucionesPointDto } from '../models/DashboardDevolucionesPointDto';
import type { DashboardKpiResponseDto } from '../models/DashboardKpiResponseDto';
import type { DashboardMarginPointDto } from '../models/DashboardMarginPointDto';
import type { DashboardMoneyPointDto } from '../models/DashboardMoneyPointDto';
import type { DashboardProductTrendResponseDto } from '../models/DashboardProductTrendResponseDto';
import type { DashboardStatusPointDto } from '../models/DashboardStatusPointDto';
import type { DashboardStockByLocationPointDto } from '../models/DashboardStockByLocationPointDto';
import type { DashboardStockIngressPointDto } from '../models/DashboardStockIngressPointDto';
import type { DashboardTopProductDto } from '../models/DashboardTopProductDto';
import type { DashboardUnitsPointDto } from '../models/DashboardUnitsPointDto';
import type { MyActivityResponseDto } from '../models/MyActivityResponseDto';
import type { PendingWorkResponseDto } from '../models/PendingWorkResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardService {
  /**
   * Actionable pending-work counts for Inicio (REG/TRL/SOL/ventas por cobrar)
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @returns PendingWorkResponseDto
   * @throws ApiError
   */
  public static dashboardControllerGetPendingWork(
    scope?: string,
  ): CancelablePromise<PendingWorkResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/pending-work',
      query: {
        scope: scope,
      },
    });
  }
  /**
   * Caller's own sales for Inicio (today's counters + last 5 sales)
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @returns MyActivityResponseDto
   * @throws ApiError
   */
  public static dashboardControllerGetMyActivity(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
  ): CancelablePromise<MyActivityResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/my-activity',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
      },
    });
  }
  /**
   * Get dashboard KPI summary
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @returns DashboardKpiResponseDto
   * @throws ApiError
   */
  public static dashboardControllerGetKpis(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
  ): CancelablePromise<DashboardKpiResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/kpis',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
      },
    });
  }
  /**
   * Get sales money trend series
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @param granularity Aggregation granularity.
   * @returns DashboardMoneyPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetSalesMoneyTrend(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
    granularity: 'day' = 'day',
  ): CancelablePromise<Array<DashboardMoneyPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/sales-money-trend',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
        granularity: granularity,
      },
    });
  }
  /**
   * Get profit margin trend series
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @param granularity Aggregation granularity.
   * @returns DashboardMarginPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetMarginTrend(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
    granularity: 'day' = 'day',
  ): CancelablePromise<Array<DashboardMarginPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/margin-trend',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
        granularity: granularity,
      },
    });
  }
  /**
   * Get refunds trend: devuelto and retenido by day
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @param granularity Aggregation granularity.
   * @returns DashboardDevolucionesPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetDevolucionesTrend(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
    granularity: 'day' = 'day',
  ): CancelablePromise<Array<DashboardDevolucionesPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/devoluciones-trend',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
        granularity: granularity,
      },
    });
  }
  /**
   * Get sales units trend series
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @param granularity Aggregation granularity.
   * @returns DashboardUnitsPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetSalesUnitsTrend(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
    granularity: 'day' = 'day',
  ): CancelablePromise<Array<DashboardUnitsPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/sales-units-trend',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
        granularity: granularity,
      },
    });
  }
  /**
   * Get stock ingress trend series
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @param granularity Aggregation granularity.
   * @returns DashboardStockIngressPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetStockIngressTrend(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
    granularity: 'day' = 'day',
  ): CancelablePromise<Array<DashboardStockIngressPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/stock-ingress-trend',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
        granularity: granularity,
      },
    });
  }
  /**
   * Get available stock grouped by location
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param asOfDate Date snapshot (ISO-8601). Defaults to now if omitted.
   * @returns DashboardStockByLocationPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetStockByLocation(
    scope?: string,
    asOfDate?: string,
  ): CancelablePromise<Array<DashboardStockByLocationPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/stock-by-location',
      query: {
        scope: scope,
        asOfDate: asOfDate,
      },
    });
  }
  /**
   * Get inventory availability status distribution
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param asOfDate Date snapshot (ISO-8601). Defaults to now if omitted.
   * @returns DashboardStatusPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetInventoryStatus(
    scope?: string,
    asOfDate?: string,
  ): CancelablePromise<Array<DashboardStatusPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/inventory-status',
      query: {
        scope: scope,
        asOfDate: asOfDate,
      },
    });
  }
  /**
   * Get sales orders status distribution
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @returns DashboardStatusPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetOrdersStatus(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
  ): CancelablePromise<Array<DashboardStatusPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/orders-status',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
      },
    });
  }
  /**
   * Get inventory transfer status distribution
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @returns DashboardStatusPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetInventoryTransfersStatus(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
  ): CancelablePromise<Array<DashboardStatusPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/inventory-transfers-status',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
      },
    });
  }
  /**
   * Get inventory record status distribution
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @returns DashboardStatusPointDto
   * @throws ApiError
   */
  public static dashboardControllerGetInventoryRecordsStatus(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
  ): CancelablePromise<Array<DashboardStatusPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/inventory-records-status',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
      },
    });
  }
  /**
   * Get top selling products by units
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @returns DashboardTopProductDto
   * @throws ApiError
   */
  public static dashboardControllerGetTopProducts(
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
  ): CancelablePromise<Array<DashboardTopProductDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/top-products',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
      },
    });
  }
  /**
   * Get sales trend by product (up to 4 products)
   * @param productIds Product IDs to get sales trend for (1 to 4 products).
   * @param scope Scope for dashboard data. Use "global" or a numeric location id.
   * @param from Start date (ISO-8601).
   * @param to End date (ISO-8601).
   * @param tz IANA timezone identifier. Reserved for future timezone-aware bucketing.
   * @param granularity Aggregation granularity.
   * @returns DashboardProductTrendResponseDto
   * @throws ApiError
   */
  public static dashboardControllerGetProductSalesTrend(
    productIds: Array<number>,
    scope?: string,
    from?: string,
    to?: string,
    tz?: string,
    granularity: 'day' = 'day',
  ): CancelablePromise<DashboardProductTrendResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/product-sales-trend',
      query: {
        scope: scope,
        from: from,
        to: to,
        tz: tz,
        granularity: granularity,
        productIds: productIds,
      },
    });
  }
}
